<template>
	<div>
		<div class="row">
			<div class="col-md-4 mb-4">
				<info-card
					:title="'Total de contas a receber'"
					icon="fa-shopping-cart"
					variant="success"
					:value="total_bills.total"
				/>
			</div>
			<div class="col-md-4 mb-4">
				<info-card
					:title="'Contas Vencidas'"
					icon="fa-shopping-cart"
					variant="danger"
					:value="over_due.total"
				/>
			</div>
			<div class="col-md-4 mb-4">
				<info-card
					:title="'Limite para Compras'"
					icon="fa-file-invoice-dollar"
					variant="primary"
					:value="total_bills.debt_limit_value - total_bills.total"
				/>
			</div>
		</div>

		<br />

		<div class="row" v-if="hasSelected">
			<div class="col-md-3">
				<div class="card">
					<div class="card-body">
						<div class="row">
							<div class="col-6">
								<small>Selecionado:</small>
							</div>
							<div class="col-6 text-right">
								<b>{{ selectedCount }}</b>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="col-md-3">
				<div class="card">
					<div class="card-body">
						<div class="row">
							<div class="col-6">
								<small>Valor</small>
							</div>
							<div class="col-6 text-right">
								<b>{{ selectedValueSum | decimal }}</b>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="col-md-6">
				<div class="card">
					<div class="card-body">
						<div class="row">
							<div class="col-3">
								<small>Saldo Devedor</small>
							</div>
							<div class="col-4 text-right">
								<b>{{ selectedBalanceDueSum | decimal }}</b>
							</div>
							<div class="col-md-5 text-right">
								<button
									v-if="this.$acl.can('billReceiveCreateEdit')"
									class="btn btn-sm btn-success"
									@click="openReceiveBillReceiveForm"
								>
									<i class="fas fa-dollar-bill" />
									<span>Receber Contas</span>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<br />
		<div class="row grid-table-heading d-md-flex d-none">
			<div class="col-md-6">Descrição</div>
			<div class="col-md-6">
				<div class="row">
					<div class="col-3 text-right">Valor Original</div>
					<div class="col-3 text-right">Saldo Devedor</div>
					<div class="col-3 text-right">Vencimento</div>
					<div class="col-3 text-right">Status</div>
				</div>
			</div>
		</div>
		<hr />
		<table-paginator :data="bills" @pagechange="select($event)">
			<template v-for="row in bills.data">
				<div
					class="row grid-table-row align-items-md-center align-items-start"
					:key="row.id"
					@click.stop="openBillReceivebleDetails(row)"
				>
					<div class="col-8 col-md-6 d-flex">
						<div>
							<b-dropdown
								variant="transparent"
								toggle-class="text-decoration-none"
								no-caret
							>
								<template v-slot:button-content>
									<i class="fas fa-ellipsis-v text-muted" />
								</template>
								<b-dropdown-item @click.stop="printBillPromissory(row)">
									<i class="fas fa-print" />
									Imprimir Promissória
								</b-dropdown-item>
								<b-dropdown-item
									@click.stop="$refs.billPaymentList.open(row.id)"
								>
									<i class="fas fa-file-invoice" />
									Ver	Recebimentos
								</b-dropdown-item>
								<b-dropdown-item
									v-if="
										row.status != 'c' && row.status != 'p' && billReceiveCancel
									"
									@click.stop="openBillReceiveCancelForm(row)"
								>
									<i class="fas fa-file-invoice" />
									Cancelar
								</b-dropdown-item>
                <b-dropdown-item @click.stop="handleArchiveBillReceive(row)">
                  <i class="fas fa-archive" />
                  Arquivar
                </b-dropdown-item>
							</b-dropdown>
						</div>
						<div class="ml-2 mt-1">
							<b-form-checkbox
								v-if="billReceiveCreateEdit"
								@click.stop
								:disabled="!(row.status == 'o')"
								size="lg"
								:value="row"
								v-model="selected"
							/>
						</div>
						<div class="ml-2 mt-1">
							<span>Documento: {{ row.document }}</span>
							<!-- <br />
            <small class="text-muted">Ver compras</small> -->
						</div>
					</div>

					<div class="col-4 col-md-6">
						<div class="row">
							<template v-if="row.value > 0">
								<div class="col-md-3 text-right d-none d-md-inline">
									{{ row.value | decimal }}
								</div>
								<div class="col-md-3 text-right">
									<b>{{ (row.value - row.received_value) | decimal }}</b>
								</div>
							</template>
							<template v-else>
								<div class="col-md-3 text-right d-none d-md-inline">
									<span class="text-success">{{
										(row.value * -1) | decimal
									}}</span>
								</div>
								<div class="col-md-3 text-right">
									<span class="text-success">{{
										((row.value - row.received_value) * -1) | decimal
									}}</span>
								</div>
							</template>
							<div class="col-md-3 text-right">
								<template v-if="row.value > 0">
									<due-date-badge ref="DueDateBadge" :date="row.due_date" />
								</template>
								<template v-else>
									<h6>
										<span class="badge badge-success text-white">Crédito</span>
									</h6>
								</template>
							</div>
							<div class="col-md-3 text-right">
								<span
									:class="['badge', 'text-white', status[row.status].class]"
									style="line-height: 1.2"
									>{{ status[row.status].text }}</span
								>
							</div>
						</div>
					</div>
				</div>
			</template>
		</table-paginator>
		<receive-bill-receive-form
			ref="receiveBillReceiveForm"
			@received="refresh"
		/>
		<bill-receiveble-cancel-form
			ref="billReceivebleCancelForm"
			@canceled="refresh"
		/>
		<bill-payment-list ref="billPaymentList" />
		<bill-receiveble-details ref="billReceivebleDetails" />
 	</div>
</template>

<script>
	import Filters from "./../../../mixins/Filters";
	import moment from "moment";
import InfoCard from '../../sections/dashboard/InfoCard.vue';
	import ReceiveBillReceiveForm from "../forms/ReceiveBillReceiveForm";
	import BillReceivebleCancelForm from "../forms/BillReceivebleCancelForm";
	import BillPaymentList from "../lists/BillPaymentList";
	import BillReceivebleDetails from "../sections/BillReceivebleDetails";
	import DueDateBadge from '../../ui/DueDateBadge.vue';
import TablePaginator from '../../sections/TablePaginator.vue';
 
	export default {
		props: {
			id: {},
		},

		components: {
			InfoCard,
			ReceiveBillReceiveForm,
			BillReceivebleCancelForm,
			BillPaymentList,
			BillReceivebleDetails,
			DueDateBadge,
			TablePaginator,
 		},

		data: function () {
			return {
				selected: [],

				searchForm: {
					id: null,
					name: null,
					status: "o",
				},

				bills: {},

				total_bills: {
					total: 0,
					debt_limit_value: 0,
				},

				over_due: {},

				status: {
					o: {
						text: "Aberto",
						class: "badge-primary",
					},

					p: {
						text: "Pago",
						class: "badge-success",
					},

					c: {
						text: "Cancelado",
						class: "badge-danger",
					},

					r: {
						text: "Renegociado",
						class: "badge-warning",
					},
				},
			};
		},

		created() {
			this.searchForm.id = this.id;

			this.$store.commit("showLoading");

			this.$store.commit("pageHasLoaded");
			axios
				.post("api/billreceiveble/selectstatusopen", this.searchForm)
				.then((response) => {
					this.bills = response.data.open;
					this.total_bills = response.data.totalReceiveble;
					this.over_due = response.data.overdue;
					this.$store.commit("hideLoading");
				})
				.catch((error) => {
					this.error = error;
				});
		},

		computed: {
			hasSelected() {
				return this.selected.length > 0;
			},

			selectedCount() {
				return this.selected.length;
			},

			selectedValueSum() {
				var sum = 0;

				for (let index in this.selected) {
					sum += parseFloat(this.selected[index].value);
				}

				return Math.round(sum * 100) / 100;
			},

			selectedBalanceDueSum() {
				var sum = 0;

				for (let index in this.selected) {
					sum +=
						parseFloat(this.selected[index].value) -
						parseFloat(this.selected[index].received_value);
				}

				return Math.round(sum * 100) / 100;
			},
			billReceiveCancel() {
				return this.$acl.can('billReceiveCancel')
			},
			billReceiveCreateEdit() {
				return this.$acl.can('billReceiveCreateEdit')

			}

		},

		methods: {
			openBillReceiveCancelForm(bill) {
				this.$refs.billReceivebleCancelForm.open(bill);
			},

			isCredit(bill) {
				return bill.value < 0;
			},

			printBillReceiveble(bill) {
				window.open("/contasareceber/imprimir-recibo/" + bill.id, "_blank");
			},

			printBillPromissory(bill) {
				window.open("/contasareceber/imprimir-promissoria/" + bill.id, "_blank");
			},

			openReceiveBillReceiveForm() {
				this.$refs.receiveBillReceiveForm.open(this.selected);
			},

			openBillReceivebleDetails(bill) {
				this.$refs.billReceivebleDetails.open(bill);
			},

			refresh() {
				this.selected = [];

				this.select();

				this.$emit("mutated");
			},

			select(page = 1) {
				this.$store.commit("pageHasLoaded");
				axios
					.post("api/billreceiveble/selectstatusopen?page=" + page, this.searchForm)
					.then((response) => {
						this.bills = response.data.open;
						this.total_bills = response.data.totalReceiveble;
						this.over_due = response.data.overdue;
					})
					.catch((error) => {
						this.error = error;
					});
			},



			getWhatsAppLink(bills) {
				let name = bills.name.replace(/ .*/, "");
				let link = "https://api.whatsapp.com/send?phone=+55" + bills.phone_wa;
				let msg =
					"&text=Olá " +
					name +
					", temos um valor em aberto referente a" +
					"sua última compra com a loja " +
					this.$store.state.company.name +
					" Aguardamos você para novas compras e tomar  cafézinho delicioso com a gente.!";

				return link + msg;
			},
    handleArchiveBillReceive(BillReceive) {
      axios
        .post("erp/billReceiveble/bill-receiveble-archive", BillReceive)
        .then((response) => {
          this.select();
        })
        .catch((error) => {
          this.select();
        });
		},
		},
	};
</script>

<style>
</style>
